import { useContext } from 'react';
import type { Location } from 'history';

import LocationContext from './LocationContext';

const useLocationContext = (): Location => {
  const location = useContext(LocationContext);
  if (!location) throw new Error('LocationsContext has no location defined');
  return location;
};

export default useLocationContext;
